import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { avatarService } from '@/services/avatar';
import { reactive } from 'vue';

export function useAvatarImport() {
    const router = useAppRouter();

    const model = reactive({
        file: null
    });

    const importFile = useCrudActions().excuteAndNotify({
        request: () => avatarService.archive(model.file),
        onSuccess: () => router.go(0),
        successMessage: 'Import successfully'
    });

    return { model, importFile };
}
